import { createAction } from "redux-ts-simple";

export const ScrollActions = {
  setHash: createAction('component/HASH'),
  reset: createAction('component/RESET'),
  setParentPage: createAction('component/PARENT')
};


// WEBPACK FOOTER //
// ./src/actions/action.js